var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":"area","height":"100%","options":_vm.options,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }